<template>
  <div class="data-header-style">
    <div>
      <div class="d-flex">
        <div class="data-arr" v-for="(item,index) in data">
          <input v-model.number="data[index]" type="text" class="form-control mr-2" placeholder="">
          <span v-if="index!==0" @click="deleteDataArr(data,index)"  class="data-arr-delete"><i class="iconfont icon-close"></i></span>
        </div>
        <div class="data-arr" v-if="data.length===0">
          <input v-model.number="data[0]" type="text" class="form-control mr-2" placeholder="">
        </div>
      </div>
      <small class="text-text">
        {{text}}
      </small>
    </div>
    <i @click="addDataArr(data)" class="iconfont icon-c_add"></i>
  </div>
</template>

<script>
  export default {
    name: "data-arr",
    props: {
      value: {
        type: Array,
        default(){
          return []
        }
      },
      text:{
        type:String,
        default:"请输入【0，255】之间整数"}
    },
 data(){
      return{
      data:this.value

      }
 },
    methods: {
      addDataArr(arr) {
        arr.push(255);
        this.$emit('input', arr);
      },
      deleteDataArr(arr, index) {
        arr.splice(index,1);
        this.$emit('input', arr);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .data-header-style {
    display: flex;
    align-items: flex-start;
    .data-arr {
      position: relative;
      .form-control{
        width: 80px;
      }
    }
    .data-arr-delete {
      position: absolute;
      right: 0;
      top: -11px;
      z-index: 3;
      color: #fff;
      background: $primary;
      width: 1.2rem;
      border-radius: 50%;
      height: 1.2rem;
      text-align: center;
      line-height: 1.2rem;
      cursor: pointer;
    }
    .icon-c_add {
      line-height: 38px;
      font-size: 2rem;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/subSystem/data-arr.vue